<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="row ts-mt-3">
        <div class="col-md-12">
          <label>{{ $t('stockCount.date') }}</label>
          <a-date-picker
            v-model="model.count_date"
            format="DD-MM-YYYY"
            valueFormat="DD-MM-YYYY"
            class="ts-w-full ts-mb-3"
          ></a-date-picker>
          <div class="validate" v-if="errors.has('count_date')">
            {{ errors.first('count_date') }}
          </div>
        </div>
        <div class="col-md-12">
          <label>{{ $t('stockCount.remark') }}</label>
          <div class="ts-w-full">
            <textarea
              v-model="model.remarks"
              rows="3"
              class="form-control"
            ></textarea>
          </div>
        </div>
        <div class="col-md-12">
          <label
            for="file"
            class="ts-border ts-p-2 ts-mt-3 ts-rounded-md ts-cursor-pointer"
            >Browse File</label
          >
          <input
            type="file"
            ref="file"
            id="file"
            class="ts-hidden"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            @change="onFileChange"
          />
          <div class="validate" v-if="errors.has('file')">
            {{ errors.first('file') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          {{ display_name }}
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-md-12 ts-space-x-3 ts-flex ts-justify-end">
          <ts-button @click="$emit('cancel')">{{ $t('cancel') }}</ts-button>
          <ts-button color="primary" @click="onImport">{{
            $t('import')
          }}</ts-button>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
export default {
  name: 'importFile',
  data() {
    return {
      loading: false,
      display_name: null,
      errors: new Errors(),
      file: undefined,
      model: {
        count_date: moment().format('DD-MM-YYYY'),
        remarks: ''
      }
    }
  },
  methods: {
    onFileChange(e) {
      this.display_name = null
      this.file = e.target.files[0]
      this.display_name = this.file.name
    },
    onImport() {
      this.loading = true
      this.errors = new Errors()

      let formData = new FormData()
      formData.append('file', this.file)
      formData.append('count_date', this.model.count_date)
      formData.append('remarks', this.model.remarks)
      this.$store
        .dispatch('stock/stockCount/importExcel', formData)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('cancel')
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearInput() {
      this.$refs.file.value = null
      this.file = undefined
    }
  }
}
</script>
